import {
  DQDashboardOrderDto,
  SectionTone,
} from "@/app/models/dqDashboard/types";
import { Box, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const formatShortDate = (value?: string | Date) => {
  if (!value) return "";
  const d = new Date(value);
  return d.toLocaleString("en-US", { month: "short", day: "2-digit" });
};

const formatWeekday = (value?: string | Date) => {
  if (!value) return "";
  const d = new Date(value);
  return d.toLocaleString("en-US", { weekday: "long" });
};

const StatusCell: React.FC<{ tone: SectionTone; o: DQDashboardOrderDto }> = ({
  tone,
  o,
}) => {
  const isYesterday = tone === "yesterday";
  const isToday = tone === "today";
  const isFuture = tone === "future";

  let label = "\u00A0";
  let color = "#000";
  let showIcon = false;
  let iconColor = "#079c0e";

  if (isYesterday) {
    label = "Delivered";
    color = "#079c0e";
    showIcon = true;
  } else if (isToday) {
    if (o.isDelivered) {
      label = "Delivered";
      color = "#079c0e";
      showIcon = true;
    } else if (o.isTruckAssigned) {
      label = "Scheduled";
      color = "#000";
      showIcon = false;
    }
  } else if (isFuture) {
    label = o.isTomorrow ? "Tomorrow" : formatWeekday(o.deliveryDate);
    color = "#000";
    showIcon = false;
  }

  if (label === "\u00A0") label = "";

  return (
    <Stack direction="row" alignItems="center">
      {showIcon && (
        <Box
          sx={{
            width: 20,
            display: "flex",
            justifyContent: "center",
            marginRight: "6px",
          }}
        >
          <CheckCircleIcon sx={{ color: iconColor }} />
        </Box>
      )}
      <Box>
        <Typography
          sx={{
            fontWeight: 700,
            color,
            fontSize: { md: "14px", sm: "12px", xs: "12px" },
          }}
        >
          {label}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {formatShortDate(o.deliveryDate)}
        </Typography>
      </Box>
    </Stack>
  );
};

export default StatusCell;
